import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import BienContext from '@/features/biens/BienContext'
import { fetchHistorique, setFilters } from '@/features/historique/historiqueSlice'
import { Pagination, Spinner } from '@/components/ui'
import { formatDate } from '@/utils/formatters'
import { useUrlFilters } from '@/hooks/useUrlFilters'

const HistoriqueInterventionsEntretiens = () => {
  const dispatch = useDispatch()
  const { bien } = useContext(BienContext)
  
  const historiqueItems = useSelector((state) => state.historique.items)
  const filters = useSelector((state) => state.historique.filters)
  const pagination = useSelector((state) => state.historique.pagination)
  const isLoading = useSelector((state) => state.historique.loadingStatus.fetchList)

  useUrlFilters({
    setFiltersAction: setFilters,
    fetchAction: (params) => fetchHistorique({ bien_id: bien?.id, ...params }),
    filters,
    allowedParams: ['page', 'limit'],
    updateUrlParams: false // Pas besoin de mettre à jour l'URL pour l'extranet
  })

  const hasData = historiqueItems.length > 0

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  }

  return (
    <div className='overflow-hidden'>
      <h3 className="text-md font-semibold mb-2">Historique d'entretien et d'intervention de votre logement</h3>
      <div className="w-full bg-primary-100 p-4 rounded-none space-y-4">
          <div className="w-full overflow-x-auto">
            <table className="table table-zebra w-full">
              <thead>
                <tr>
                  <th>Prestataire</th>
                  <th>Date</th>
                  <th>Détails</th>
                </tr>
              </thead>
              <tbody>
              { isLoading && <tr>
                  <td colSpan="3" className="text-center">
                    <Spinner color='primary'/>
                  </td>
                </tr>
              }
              { !isLoading && !hasData && <tr>
                  <td colSpan="3" className="text-center py-4 text-gray-600 italic">
                    Aucun entretien ni aucune intervention ne sont intervenus durant votre bail
                  </td>
                </tr>
              }
              { !isLoading && hasData && historiqueItems.map((item, index) => (
                  <tr key={`${item.type}-${item.id}-${index}`}>
                    <td>{item.prestataire?.nom_complet || 'Non spécifié'}</td>
                    <td>
                      {formatDate(item.date)}
                    </td>
                    <td>
                      {item.details || (item.type === 'intervention' ? 'Intervention' : 'Entretien') }
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        {pagination.totalPages > 1 && (
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  )
}

export default HistoriqueInterventionsEntretiens